import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

// #413 — unread: this person has not opened the event yet (per person; opening it removes the mark).
// A blue dot before the title; the word is for screen readers only (never colour alone: the title is bold too).
export function UnreadDot({ className }: { className?: string }) {
  const { t } = useTranslation('events')
  return (
    <>
      <span
        data-unread-dot
        aria-hidden
        className={cn('inline-block h-2 w-2 shrink-0 rounded-full bg-[var(--unread)]', className)}
      />
      <span className="sr-only">{t('unread.dot')}</span>
    </>
  )
}
